<template>
    <div class="flex min-h-screen bg-surface-50 dark:bg-surface-950">
        <AppSidebar :mobile-open="mobileOpen" @close="mobileOpen = false" />

        <div class="flex min-h-screen min-w-0 flex-1 flex-col">
            <AppTopbar @toggle-mobile="mobileOpen = true" />

            <main class="flex-1 overflow-x-hidden">
                <div class="mx-auto w-full max-w-6xl p-4 sm:p-6 lg:p-8">
                    <router-view />
                </div>
            </main>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'

    import AppSidebar from '@/layouts/components/AppSidebar.vue'
    import AppTopbar from '@/layouts/components/AppTopbar.vue'

    const mobileOpen = ref(false)
</script>
